import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { NumberFormatFloat } from "utils/HelperFunction";
export default function FinancialTotal(param) {
    var totalPrice = param.totalPrice, poSplitPrice = param.poSplitPrice, setIsDiffPO = param.setIsDiffPO;
    var _useState = _sliced_to_array(useState({
        isDiff: false,
        color: "",
        diffPrice: 0,
        diffText: ""
    }), 2), diffObj = _useState[0], setDiffObj = _useState[1];
    useEffect(function() {
        var realDiffPrice = NumberFormatFloat(poSplitPrice) - NumberFormatFloat(totalPrice);
        var color = realDiffPrice < 0 ? "text-[#FF0000]" : "text-[#10B02A]";
        var diffText = realDiffPrice < 0 ? "เพิ่ม" : "ลด";
        var diffPrice = Math.abs(realDiffPrice);
        var isDiff = realDiffPrice !== 0;
        setDiffObj(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                isDiff: isDiff,
                color: color,
                diffText: diffText,
                diffPrice: diffPrice
            });
        });
        setIsDiffPO(isDiff);
    }, [
        totalPrice
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(NumericFormat, {
                displayType: "text",
                thousandSeparator: ",",
                decimalScale: 2,
                fixedDecimalScale: true,
                value: totalPrice
            }),
            diffObj.isDiff && /*#__PURE__*/ _jsxs("div", {
                className: "".concat(diffObj.color, " text-[8px] font-[400]"),
                children: [
                    diffObj.diffText,
                    " ",
                    diffObj.diffPrice.toFixed(2)
                ]
            })
        ]
    });
}
